
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-03-10 (1.0.0) (jhoward)
 *      -
 *
 *    2023-04-24 (1.1.0) (jhoward)
 *      - Add TypeScript support to <menu-tag-legend>.
 *
 *    2024-07-16 (1.1.1) (jhoward)
 *      - Add legend-specific CSS for menu tags to <menu-tag-legend>.
 *
 *    2024-07-19 (1.1.2) (jhoward)
 *      - Render tag titles as after pseudo-element in <menu-tag-legend>.
 *
 *    2025-02-12 (1.1.3) (jhoward)
 *      - Add custom style to prime black and white tag in <menu-tag-legend>.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove <menu-tag-legend>::tags computed property.
 *      - Remove "items" property in <menu-tag-legend>.
 *      - Add "tags" property in <menu-tag-legend>.
 */

import {defineComponent, PropType} from "vue";
import MenuTag from "./menu-tag.vue";
import {MenuTagModel} from "./defs";

export default defineComponent({
  components: {
    MenuTag
  },
  name: 'menu-tag-legend',
  props: {
    tags: {
      type: Array as PropType<MenuTagModel[]>,
      required: true
    },
    menuType: {
      type: String,
      default: 'visual',
      validator(value: string) {
        return ['visual', 'textual'].includes(value);
      }
    }
  },
})
